module.exports = __webpack_public_path__ + "static/Eyeglasss4_4-57632a0c88e942deb003ca06ff7afadb.png";